import * as _ from 'lodash';
import { ITask } from '../../../admin/tasks-page/tasks/task.interface';
import { IProduct } from '../../../admin/products-page/products/products.interface';
import { TaxPercentage } from '../../constants/global.constants';

export interface IDetailItem {
  task?: ITask;
  serviceAgreement?: any;
  product?: IProduct;
  name?: string; // deprecated
  detail: string;
  description?: string;
  cost?: number;
  price?: number;
  quantity?: number;
  unit?: string;
  subtotal?: number;
  taxPercentage?: number;
  tax?: number;
  total?: number;
  costsubtotal?: number;

  details?: IDetailItem[];
}

const emptyDetailItem: IDetailItem = { detail: "", description: '', quantity: 1, unit: 'unidad', cost: 0, costsubtotal: 0, price: 0, subtotal: 0, taxPercentage: TaxPercentage, tax: 0, total: 0 }
export const getEmptyDetailItem = () => _.cloneDeep(emptyDetailItem)